
import { Component, Prop, Vue } from "vue-property-decorator";
import BadgeColor from "@/entities/BadgeColor";

@Component
export default class Badge extends Vue {
  @Prop({ type: String, required: true }) readonly value!: string;
  @Prop({ type: Boolean, default: false }) readonly showIcon!: Boolean;
  @Prop({ type: String, required: true }) readonly color!: BadgeColor;
  @Prop({ type: String, default: "normal" }) readonly size!: string;
  @Prop({ type: String, default: undefined }) readonly styleClasses!: string;

  BadgeColor: typeof BadgeColor = BadgeColor;

  get classes(): Record<string, boolean> {
    return {
      [this.styleClasses]: Boolean(this.styleClasses),
      "h-8 flex justify-center items-center font-400 text-xs px-2": true,
      "items-center justify-center font-normal": !this.styleClasses,
      "redBg redText ": this.color === this.BadgeColor.WARNING,
      "redBg redText": this.color === this.BadgeColor.DANGER,
      offered: this.color === this.BadgeColor.OFFERED,
      open: this.color === this.BadgeColor.OPEN,
      "yelBg yelText": this.color === this.BadgeColor.INTERNAL,
      "bg-lightBlue text-badgeBlue": this.color === this.BadgeColor.INFO,
      "bg-badge-success-bg text-badge-success-text":
        this.color === this.BadgeColor.SUCCESS,
      "bg-badge-active": this.color === this.BadgeColor.ACTIVE,
      "bg-white text-primary-black border border-black":
        this.color === this.BadgeColor.ADD_TO_COMPANY,
      "bg-white border border-gray-500 text-gray-500":
        this.color === this.BadgeColor.OUTLINE,
      "border border-primary-500 text-white":
        this.color === this.BadgeColor.PRIMARY_OUTLINE,
      ["text-xs"]: this.size === "normal",
      ["text-xs min-w-28"]: this.size === "lg",
    };
  }
}
